module.exports = __webpack_public_path__ + "static/media/twelveth_miller_house4.e1d5be0e.png";